import React, { useEffect, useMemo, useRef, useState } from "react";
import { Tooltip } from "antd";
import { GetDecryptToken } from "../../helper/http-common";

const ExitFullscreenIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <path
      d="M1 5.5h4.5V1M15 5.5h-4.5V1M1 10.5h4.5V15M15 10.5h-4.5V15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const EnterFullscreenIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <path
      d="M5.5 1H1v4.5M10.5 1H15v4.5M5.5 15H1v-4.5M10.5 15H15v-4.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IncentiveDashboard = () => {
  const panelRef = useRef(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const iframeSrc = useMemo(() => {
    const baseUrl = (
      process.env.REACT_APP_INCENTIVE_URL ||
      "http://localhost:65483/Q_incentive"
    ).replace(/\/$/, "");
    const token = GetDecryptToken() || "";
    const separator = baseUrl.includes("?") ? "&" : "?";
    return `${baseUrl}${separator}key=${encodeURIComponent(token)}`;
  }, []);

  useEffect(() => {
    const onFullscreenChange = () => {
      const panel = panelRef.current;
      setIsFullscreen(Boolean(panel && document.fullscreenElement === panel));
    };

    document.addEventListener("fullscreenchange", onFullscreenChange);
    return () =>
      document.removeEventListener("fullscreenchange", onFullscreenChange);
  }, []);

  const toggleFullscreen = () => {
    const panel = panelRef.current;
    if (!panel) return;

    if (document.fullscreenElement === panel) {
      document.exitFullscreen?.();
      return;
    }

    const request =
      panel.requestFullscreen ||
      panel.webkitRequestFullscreen ||
      panel.msRequestFullscreen;

    request?.call(panel);
  };

  return (
    <div className="dashboard app-content content">
      <div className="content-wrapper">
        <div className="d-flex justify-content-between mb-3 align-items-center">
          <h5 className="text-info mb-0">Incentive Dashboard</h5>
          {!isFullscreen && (
            <button
              type="button"
              className="btn btn-primary d-flex align-items-center"
              onClick={toggleFullscreen}
              aria-label="View in full screen"
              title="View in full screen"
            >
              <span className="mr-10">View in full screen</span>
              <EnterFullscreenIcon />
            </button>
          )}
        </div>
        <div
          ref={panelRef}
          className={`content-body card p-0 incentive-fs-panel${isFullscreen ? " is-fullscreen" : ""
            }`}
          style={{
            position: "relative",
            overflow: "hidden",
            background: "#fff",
          }}
        >
          <iframe
            className="incentive-fs-iframe"
            title="Incentive Dashboard"
            src={iframeSrc}
            style={{
              border: 0,
              display: "block",
              width: "100%",
              minHeight: "calc(100vh - 180px)",
              height: "900px",
            }}
            allowFullScreen
          />
          {isFullscreen && (
            <Tooltip
              title="Exit full screen"
              placement="right"
              getPopupContainer={() => panelRef.current || document.body}
            >
              <button
                type="button"
                className="incentive-fs-exit"
                onClick={toggleFullscreen}
                aria-label="Exit full screen"
                title="Exit full screen"
              >
                <ExitFullscreenIcon />
              </button>
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  );
};

export default IncentiveDashboard;
